<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i class="fa fa-search searchBtn ml-3 mt-1" title="ძებნა"></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ორგანიზაციის დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            data-backdrop="static"
            data-keyboard="false"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      ref="addModal"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პროდუქტის მენიუ ჯგუფების დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="container py-4">
              <div class="row">
                <div class="col-md-12">
                  <ul id="tabsJustified" class="nav nav-tabs">
                    <li class="nav-item">
                      <a
                        data-target="#productMenuGroup"
                        data-toggle="tab"
                        class="nav-link small text-uppercase modal-nav active pointer"
                        >პროდუქტის მენიუ ჯგუფები</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        data-target="#product"
                        data-toggle="tab"
                        class="nav-link small text-uppercase modal-nav pointer"
                        >პროდუქტი</a
                      >
                    </li>
                  </ul>
                  <br />
                  <div id="tabsJustifiedContent" class="tab-content">
                    <div
                      id="productMenuGroup"
                      class="tab-pane fade active show"
                      v-bind:class="{ active: isActive, show: isActive }"
                    >
                      <div class="row">
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="text"
                                id="nameGeAdd"
                                class="form-control"
                                placeholder="სახელი ქართულად"
                                autofocus="autofocus"
                                v-model="productMenuGroup.nameGe"
                                v-on:input="$v.productMenuGroup.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.productMenuGroup.nameGe.$error,
                                  valid:
                                    $v.productMenuGroup.nameGe.$dirty &&
                                    !$v.productMenuGroup.nameGe.$invalid,
                                }"
                              />
                              <label for="nameGeAdd">სახელი ქართულად</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="nameEnAdd"
                                class="form-control"
                                placeholder="English Name"
                                v-model="productMenuGroup.nameEn"
                                v-on:input="$v.productMenuGroup.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.productMenuGroup.nameEn.$error,
                                  valid:
                                    $v.productMenuGroup.nameEn.$dirty &&
                                    !$v.productMenuGroup.nameEn.$invalid,
                                }"
                              />
                              <label for="nameEnAdd">English Name</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="nameRuAdd"
                                class="form-control"
                                placeholder="имя на русском"
                                v-model="productMenuGroup.nameRu"
                                v-on:input="$v.productMenuGroup.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.productMenuGroup.nameRu.$error,
                                  valid:
                                    $v.productMenuGroup.nameRu.$dirty &&
                                    !$v.productMenuGroup.nameRu.$invalid,
                                }"
                              />
                              <label for="nameRuAdd">имя на русском</label>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnlyMainAdd"
                                v-model="productMenuGroup.showOnlyMain"
                              />
                              <label
                                class="form-check-label"
                                for="showOnlyMainAdd"
                                >მხოლოდ მთავარზე ჩვენება</label
                              >
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnDashboardAdd"
                                v-model="productMenuGroup.showOnDashboard"
                              />
                              <label
                                class="form-check-label"
                                for="showOnDashboardAdd"
                                >Dashboard-ზე ჩვენება</label
                              >
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnlyDashboardAdd"
                                v-model="productMenuGroup.showOnlyDashboard"
                              />
                              <label
                                class="form-check-label"
                                for="showOnlyDashboardAdd"
                                >მხოლოდ Dashboard-ზე ჩვენება</label
                              >
                            </div>
                          </div>
                        </form>
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="number"
                                id="orderAdd"
                                class="form-control"
                                placeholder="პრიორიტეტი"
                                v-model="productMenuGroup.order"
                                v-on:input="$v.productMenuGroup.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.productMenuGroup.order.$error,
                                  valid:
                                    $v.productMenuGroup.order.$dirty &&
                                    !$v.productMenuGroup.order.$invalid,
                                }"
                              />
                              <label for="orderAdd">პრიორიტეტი</label>
                            </div>
                            <div class="form-label-group">
                              <div class="dropdown mt-3">
                                <button
                                  class="btn green-color dropdown-toggle"
                                  type="button"
                                  id="dropdownProductCategorySelect"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  {{ dropDownProductCategory }}
                                </button>
                                <div
                                  class="dropdown-menu"
                                  aria-labelledby="dropdownProductCategorySelect"
                                  style="
                                    max-height: 400px;
                                    overflow: hidden auto;
                                  "
                                >
                                  <a
                                    class="dropdown-item pointer"
                                    v-for="categoryValue in productCategoriesArray"
                                    :key="categoryValue.id"
                                    v-on:click="$v.productMenuGroup.$touch"
                                    @click="
                                      dropDownCategoryClick(
                                        categoryValue.nameGe,
                                        categoryValue.id
                                      )
                                    "
                                    v-bind:class="{
                                      'error-border':
                                        $v.productMenuGroup.prodCategoryId
                                          .$error,
                                      valid:
                                        $v.productMenuGroup.prodCategoryId
                                          .$dirty &&
                                        !$v.productMenuGroup.prodCategoryId
                                          .$invalid,
                                    }"
                                    >{{ categoryValue.nameGe }}</a
                                  >
                                </div>
                              </div>
                            </div>
                            <div v-if="productSubCategoriesArray != 0">
                              <div class="form-label-group">
                                <div class="dropdown mt-3">
                                  <button
                                    class="btn green-color dropdown-toggle"
                                    type="button"
                                    id="dropdownProductSubCategorySelect"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    {{ dropDownProductSubCategory }}
                                  </button>
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownProductSubCategorySelect"
                                    style="
                                      max-height: 400px;
                                      overflow: hidden auto;
                                    "
                                  >
                                    <a
                                      class="dropdown-item pointer"
                                      v-for="subCategoryValue in productSubCategoriesArray"
                                      :key="subCategoryValue.id"
                                      v-on:click="$v.productMenuGroup.$touch"
                                      @click="
                                        dropDownSubCategoryClick(
                                          subCategoryValue.nameGe,
                                          subCategoryValue.id
                                        )
                                      "
                                      >{{ subCategoryValue.nameGe }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="productSubSubCategoriesArray != 0">
                              <div class="form-label-group">
                                <div class="dropdown mt-3">
                                  <button
                                    class="btn green-color dropdown-toggle"
                                    type="button"
                                    id="dropdownProductSubSubCategorySelect"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    {{ dropDownProductSubSubCategory }}
                                  </button>
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownProductSubSubCategorySelect"
                                    style="
                                      max-height: 400px;
                                      overflow: hidden auto;
                                    "
                                  >
                                    <a
                                      class="dropdown-item pointer"
                                      v-for="subSubCategoryValue in productSubSubCategoriesArray"
                                      :key="subSubCategoryValue.id"
                                      v-on:click="$v.productMenuGroup.$touch"
                                      @click="
                                        dropDownSubSubCategoryClick(
                                          subSubCategoryValue.nameGe,
                                          subSubCategoryValue.id
                                        )
                                      "
                                      >{{ subSubCategoryValue.nameGe }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnMainAdd"
                                v-model="productMenuGroup.showOnMain"
                              />
                              <label
                                class="form-check-label"
                                for="showOnMainAdd"
                                >მთავარზე ჩვენება</label
                              >
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showInSubsAdd"
                                v-model="productMenuGroup.showInSubs"
                              />
                              <label
                                class="form-check-label"
                                for="showInSubsAdd"
                                >ქვე კატეგორიებში ჩვენება</label
                              >
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div id="product" class="tab-pane fade">
                      <div class="row">
                        <autocomplete
                          :list="filteredProductsArray"
                          class="ml-4"
                          :resetField="resetAutocomplete"
                          optionField="nameGe"
                          @input="onAutocompleteInput"
                          placeHolderValue="პროდუქტი"
                          v-on:input="$v.productMenuGroup.$touch"
                        >
                          <div slot="list-item" slot-scope="{ item }">
                            {{ item.nameGe }}
                            <br />
                            {{ item.descGe }}
                          </div>
                        </autocomplete>
                      </div>
                      <div v-if="editNewProduct" class="row">
                        <form class="col-12 col-md-6">
                          <div class="form-label-group mt-3">
                            <input
                              type="text"
                              id="nameGeAddProduct"
                              class="form-control"
                              placeholder="სახელი ქართულად"
                              v-model="changedProduct.nameGe"
                              v-on:input="$v.changedProduct.$touch"
                              v-bind:class="{
                                'error-border': $v.changedProduct.nameGe.$error,
                                valid:
                                  $v.changedProduct.nameGe.$dirty &&
                                  !$v.changedProduct.nameGe.$invalid,
                              }"
                            />
                            <label for="nameGeAddProduct"
                              >სახელი ქართულად</label
                            >
                          </div>
                          <div class="form-label-group mt-3">
                            <input
                              type="text"
                              id="nameEnAddProduct"
                              class="form-control"
                              placeholder="English Name"
                              v-model="changedProduct.nameEn"
                              v-on:input="$v.changedProduct.$touch"
                              v-bind:class="{
                                'error-border': $v.changedProduct.nameEn.$error,
                                valid:
                                  $v.changedProduct.nameEn.$dirty &&
                                  !$v.changedProduct.nameEn.$invalid,
                              }"
                            />
                            <label for="nameEnAddProduct">English Name</label>
                          </div>
                          <div class="form-label-group mt-3">
                            <input
                              type="text"
                              id="nameRuAddProduct"
                              class="form-control"
                              placeholder="имя на русском"
                              v-model="changedProduct.nameRu"
                              v-on:input="$v.changedProduct.$touch"
                              v-bind:class="{
                                'error-border': $v.changedProduct.nameRu.$error,
                                valid:
                                  $v.changedProduct.nameRu.$dirty &&
                                  !$v.changedProduct.nameRu.$invalid,
                              }"
                            />
                            <label for="nameRuAddProduct">имя на русском</label>
                          </div>
                        </form>
                        <form class="col-12 col-md-6">
                          <div class="form-label-group mt-3">
                            <input
                              type="number"
                              id="orderPriorityAddProduct"
                              class="form-control"
                              placeholder="პრიორიტეტი"
                              v-model="changedProduct.orderPriority"
                              v-on:input="$v.changedProduct.$touch"
                              v-bind:class="{
                                'error-border':
                                  $v.changedProduct.orderPriority.$error,
                                valid:
                                  $v.changedProduct.orderPriority.$dirty &&
                                  !$v.changedProduct.orderPriority.$invalid,
                              }"
                            />
                            <label for="orderPriorityAddProduct"
                              >პრიორიტეტი</label
                            >
                          </div>
                          <form method="post" class="mt-3">
                            <div class="custom-file">
                              <input
                                type="file"
                                ref="file"
                                multiple
                                @change="onFileSelected"
                                class="custom-file-input"
                                id="validatedCustomFile"
                              />
                              <label
                                class="custom-file-label"
                                for="validatedCustomFile"
                              ></label>
                            </div>
                          </form>
                          <img
                            v-if="!editImg"
                            class="img-thumbnail mt-3"
                            :src="imageUrl(changedPrductImageUpuloadName)"
                          />
                          <img
                            v-if="editImg"
                            class="img-thumbnail mt-3"
                            v-bind:src="imagePreview"
                            v-show="showPreview"
                          />
                        </form>
                      </div>
                      <div v-if="editNewProduct" class="row mt-3">
                        <button
                          type="button"
                          class="btn btn-success"
                          :disabled="
                            !$v.changedProduct.$dirty ||
                            $v.changedProduct.$error
                          "
                          @click="
                            $v.changedProduct.$touch(), addChangedProduct()
                          "
                        >
                          დამახსოვრება
                        </button>
                      </div>
                      <div class="row">
                        <div v-if="productMenuGroup.products.length > 0">
                          <div
                            v-for="product in selectedProductsArray"
                            :key="product.id"
                            class="modal-card card mt-3"
                          >
                            <div class="card-body row">
                              <div class="col-8">
                                სახელი: {{ product.nameGe }}
                              </div>
                              <div class="col-1">
                                <i
                                  class="fa fa-pencil-alt editBtn"
                                  title="რედაქტირება"
                                  @click="editProductFormList(product)"
                                ></i>
                              </div>
                              <div class="col-1 ml-3">
                                <i
                                  class="fas fa-times deleteBtn"
                                  title="წაშლა"
                                  v-on:click="$v.productMenuGroup.$touch"
                                  @click="removeProductFormList(product.id)"
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              v-if="!isActiveModalPrepare"
              type="button"
              class="btn btn-success"
              :disabled="
                !$v.productMenuGroup.$dirty || $v.productMenuGroup.$error
              "
              @click="$v.productMenuGroup.$touch(), addProductMenuGroup()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isActiveModalPrepare"
              type="button"
              class="btn btn-success"
              :disabled="
                !$v.productMenuGroup.$dirty || $v.productMenuGroup.$error
              "
              @click="$v.productMenuGroup.$touch(), editProductMenuGroup()"
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">სახელი ქართულად</th>
            <th class="numeric">English Name</th>
            <th class="numeric">имя на русском</th>
            <th class="numeric">პროდუქტი</th>
            <th class="numeric">მთავარზე ჩვენება</th>
            <th class="numeric">რედაქტირება</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="value in productMenuGroupsArray"
            :key="value.identificationCode"
          >
            <td data-title="სახელი ქართულად" class="numeric">
              {{ value.nameGe }}
            </td>
            <td data-title="English Name" class="numeric">
              {{ value.nameEn }}
            </td>
            <td data-title="имя на русском" class="numeric">
              {{ value.nameRu }}
            </td>
            <td data-title="პროდუქტი" class="numeric">{{ value.order }}</td>
            <td data-title="მთავარზე ჩვენება" class="numeric">
              {{ value.showOnMain }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="
                    clearData(), editFillInputs(value), modalPrepareEdit()
                  "
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="getDeleteId(value.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ორგანიზაციის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteProductMenuGroup()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import ProductMenuGroupTemplate from "../common/ProductMenuGroupTemplate.vue";
import { required } from "vuelidate/lib/validators";
import { baseURL } from "../../settings/settings.js";

const _baseUrl = baseURL + "api/prod/1.0/";

export default {
  name: "productMenuGroup",
  components: { autocomplete: ProductMenuGroupTemplate },
  data() {
    return {
      showModal: false,
      productMenuGroup: {
        id: "",
        nameGe: "",
        nameEn: "",
        nameRu: "",
        order: null,
        prodCategoryId: null,
        prodSubCategoryId: null,
        showInSubs: false,
        showOnDashboard: false,
        showOnMain: false,
        showOnlyDashboard: false,
        showOnlyMain: false,
        products: [],
      },
      category: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        hasChildren: false,
        iconSrc: "",
      },
      subCategory: {
        id: null,
        categoryId: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        iconSrc: "",
        hasChildren: false,
      },
      subSubCategory: {
        id: null,
        subCategoryId: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        iconSrc: "",
        hasChildren: false,
      },
      product: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        image: null,
        itemPrice: null,
        ourPrice: null,
        standardPoint: null,
        pointCorrection: "",
        legalId: "",
        properties: [],
        categories: [],
        subCategories: [],
        subCategories2: [],
      },
      changedProduct: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        orderPriority: null,
        image: null,
      },
      isActive: false,
      isActiveModalPrepare: false,
      resetAutocomplete: false,
      dropDownProductCategory: "აირჩიეთ კატეგორია",
      dropDownProductSubCategory: "აირჩიეთ ქვე კატეგორია",
      dropDownProductSubSubCategory: "აირჩიეთ ქვე ქვე კატეგორია",
      changedPrductImageUpuloadName: "Choose FIle ...",
      editNewProduct: false,
      editImg: false,
      imagePreview: null,
      showPreview: null,
      productCategoriesArray: [],
      productSubCategoriesArray: [],
      productSubSubCategoriesArray: [],
      productMenuGroupsArray: [],
      productsArray: [],
      filteredProductsArray: [],
      selectedProductsArray: [],
      productAutocompleteArray: [],
    };
  },
  validations: {
    productMenuGroup: {
      nameGe: {
        required,
      },
      nameEn: {
        required,
      },
      nameRu: {
        required,
      },
      order: {
        required,
      },
      prodCategoryId: {
        required,
      },
      products: {
        required,
      },
    },
    changedProduct: {
      nameGe: {
        required,
      },
      nameEn: {
        required,
      },
      nameRu: {
        required,
      },
      orderPriority: {
        required,
      },
      image: {
        required,
      },
    },
  },
  async created() {
    let productMenuGroupResult = await this.$http.getProductMenuGroup();
    this.productMenuGroupsArray = productMenuGroupResult.data.res;

    let productCategoriesResult = await this.$http.getProductCategory();
    this.productCategoriesArray = productCategoriesResult.data.res;

    let productResult = await this.$http.getProduct();
    this.productsArray = productResult.data.res;
  },

  methods: {
    async addProductMenuGroup() {
      try {
        let productMenuGroupObjectAdd = {
          nameGe: this.productMenuGroup.nameGe,
          nameEn: this.productMenuGroup.nameEn,
          nameRu: this.productMenuGroup.nameRu,
          order: this.productMenuGroup.order,
          prodCategoryId: this.productMenuGroup.prodCategoryId,
          prodSubCategoryId: this.productMenuGroup.prodSubCategoryId,
          showInSubs:
            this.productMenuGroup.showInSubs === null
              ? false
              : this.productMenuGroup.showInSubs,
          showOnDashboard:
            this.productMenuGroup.showOnDashboard === null
              ? false
              : this.productMenuGroup.showOnDashboard,
          showOnlyDashboard:
            this.productMenuGroup.showOnlyDashboard === null
              ? false
              : this.productMenuGroup.showOnlyDashboard,
          showOnlyMain:
            this.productMenuGroup.showOnlyMain === null
              ? false
              : this.productMenuGroup.showOnlyMain,
          showOnMain:
            this.productMenuGroup.showOnMain === null
              ? false
              : this.productMenuGroup.showOnMain,
          products: this.productMenuGroup.products,
        };

        let productMenuGroupAddResult = await this.$http.postProductMenuGroup(
          productMenuGroupObjectAdd
        );

        if (productMenuGroupAddResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის მენიუ გრუპი წარმატებით დაემატა");
          let productMenuGroupResult = await this.$http.getProductMenuGroup();
          this.productMenuGroupsArray = productMenuGroupResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის მენიუ გრუპის დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editProductMenuGroup() {
      //ვალიდაცები
      if (this.productMenuGroup.prodCategoryId === null) {
        bus.$emit("warning", "გთხოვთ აირჩიოთ კატეგორია");
        return;
      }
      if (
        this.productSubCategoriesArray != 0 &&
        this.productMenuGroup.prodSubCategoryId === null
      ) {
        bus.$emit("warning", "გთხოვთ აირჩიოთ ქვე კატეგორია");
        return;
      }
      if (
        this.productSubSubCategoriesArray != 0 &&
        this.productMenuGroup.prodSubCategory2Id === null
      ) {
        bus.$emit("warning", "გთხოვთ აირჩიოთ ქვე ქვე კატეგორია");
        return;
      }

      console.log(this.productMenuGroup);
      //return;
      try {
        let productMenuGroupEditResult = await this.$http.putProductMenuGroup(
          this.productMenuGroup
        );

        if (productMenuGroupEditResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის მენიუ გრუპი წარმატებით დარედაქტირდა");
          let productMenuGroupResult = await this.$http.getProductMenuGroup();
          this.productMenuGroupsArray = productMenuGroupResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის მენიუ გრუპის რედაქტირების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteProductMenuGroup() {
      try {
        let productMenuGroupDeleteResult =
          await this.$http.deleteProductMenuGroup(this.productMenuGroup.id);

        if (productMenuGroupDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის მენიუ გრუპი წარმატებით წაიშალა");
          let productMenuGroupResult = await this.$http.getProductMenuGroup();
          this.productMenuGroupsArray = productMenuGroupResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის მენიუ გრუპის წაშლის დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(row) {
      this.modalPrepare();
      let productMenuGroupById = await this.$http.getByIDProductMenuGroup(
        row.id
      );
      if (productMenuGroupById.status === 200) {
        this.productMenuGroup = productMenuGroupById.data.res;
        this.selectedProductsArray = [
          ...productMenuGroupById.data.res.products,
        ];
      }

      ///
      if (this.productMenuGroup.prodCategoryId != null) {
        this.dropDownProductCategory = this.getProductCategoryName(
          this.productMenuGroup.prodCategoryId
        );

        let productSubCategoryResult =
          await this.$http.getByIDProductSubCategory(
            this.productMenuGroup.prodCategoryId
          );
        this.productSubCategoriesArray = productSubCategoryResult.data.res;
      }

      ///
      if (this.productMenuGroup.prodSubCategoryId != null) {
        this.dropDownProductSubCategory = this.getProductSubCategoryName(
          this.productMenuGroup.prodSubCategoryId
        );

        let productSubSubCategoryResult =
          await this.$http.getByIDProductSubSubCategory(
            this.productMenuGroup.prodSubCategoryId
          );
        this.productSubSubCategoriesArray =
          productSubSubCategoryResult.data.res;
      }

      ///
      if (this.productMenuGroup.prodSubCategory2Id != null) {
        this.dropDownProductSubSubCategory = this.getProductSubSubCategoryName(
          this.productMenuGroup.prodSubCategory2Id
        );
      }

      this.filteredProductsArray = [];
      for (let i = 0; i < this.productsArray.length; i++) {
        var cnt = this.productsArray[i].productProdCategoryDetailes.filter(
          (f) => f.categoryId == this.productMenuGroup.prodCategoryId
        ).length;

        var cntExists = this.productMenuGroup.products.filter(
          (f) => f.id == this.productsArray[i].id
        ).length;

        if (cnt > 0 && cntExists == 0) {
          this.filteredProductsArray.push(this.productsArray[i]);
        }
      }

      /*
      if (this.productMenuGroup.prodCategoryId === null) {
        let productSubCategoryByID = await this.$http.getByIDProductSubCategory(
          this.productMenuGroup.prodSubCategoryId
        );
        this.subCategory = productSubCategoryByID.data.res;

        console.log(1111111);

        let productSubCategoryResult =
          await this.$http.getByIDProductSubSubCategory(
            this.subCategory.categoryId
          );
        this.productSubCategoriesArray = productSubCategoryResult.data.res;
      } else {
        this.dropDownProductCategory = this.getProductCategoryName(
          this.productMenuGroup.prodCategoryId
        );
      }
      if (this.productMenuGroup.prodSubCategoryId === null) {
        let productSubCategoryResult = await this.$http.getProductSubCategory({
          id: this.productMenuGroup.prodCategoryId,
          lang: "ka-GE",
        });
        this.productSubCategoriesArray = productSubCategoryResult.data.res;
      }
      this.dropDownProductSubCategory = this.getProductSubCategoryName(
        this.productMenuGroup.prodSubCategoryId
      );
      */
    },
    getDeleteId(id) {
      this.productMenuGroup.id = id;
    },
    addChangedProduct(onEdit) {
      let productIndex = this.productMenuGroup.products.findIndex(
        (d) => d.id === this.changedProduct.id
      );
      let productSelectedIndex = this.selectedProductsArray.findIndex(
        (d) => d.id === this.changedProduct.id
      );
      if (productIndex !== -1) {
        this.productMenuGroup.products.splice(productIndex, 1);
        this.selectedProductsArray.splice(productSelectedIndex, 1);
        this.productMenuGroup.products.push(this.changedProduct);
        this.selectedProductsArray.push(this.changedProduct);
        this.changedProduct = {
          id: null,
          nameGe: "",
          nameEn: "",
          nameRu: "",
          orderPriority: null,
          image: null,
        };
        this.editNewProduct = false;
      }
    },
    removeProductFormList(productId) {
      let productIndex = this.productMenuGroup.products.findIndex(
        (d) => d.id === productId
      );
      this.productMenuGroup.products.splice(productIndex, 1);
      let selectedProductIndex = this.selectedProductsArray.findIndex(
        (d) => d.id === productId
      );
      this.selectedProductsArray.splice(selectedProductIndex, 1);
    },
    editProductFormList(product, productAlreadyChanged) {
      if (productAlreadyChanged) {
        this.changedProduct.image = product.image;
        this.changedPrductImageUpuloadName = product.image;
        this.changedProduct.orderPriority = product.orderPriority;
      } else {
        this.changedProduct.image = product.mainImage;
        this.changedPrductImageUpuloadName = product.mainImage;
      }
      this.changedProduct.id = product.id;
      this.changedProduct.nameGe = product.nameGe;
      this.changedProduct.nameEn = product.nameEn;
      this.changedProduct.nameRu = product.nameRu;

      let selectedProductIndex = this.selectedProductsArray.findIndex(
        (d) => d.id === this.changedProduct.id
      );
      this.selectedProductsArray.splice(selectedProductIndex, 1);
      this.editNewProduct = true;
    },
    getProductCategoryName(id) {
      let productCategoryIndex = this.productCategoriesArray.findIndex(
        (d) => d.id === id
      );
      if (productCategoryIndex !== -1) {
        return this.productCategoriesArray[productCategoryIndex].nameGe;
      }
    },
    getProductSubCategoryName(id) {
      let productSubCategoryIndex = this.productSubCategoriesArray.findIndex(
        (d) => d.id === id
      );
      if (productSubCategoryIndex !== -1) {
        return this.productSubCategoriesArray[productSubCategoryIndex].nameGe;
      } else {
        return "აირჩიეთ ქვე კატეგორია";
      }
    },
    getProductSubSubCategoryName(id) {
      let productSubSubCategoryIndex =
        this.productSubSubCategoriesArray.findIndex((d) => d.id === id);
      if (productSubSubCategoryIndex !== -1) {
        return this.productSubSubCategoriesArray[productSubSubCategoryIndex]
          .nameGe;
      } else {
        return "აირჩიეთ ქვე ქვე კატეგორია";
      }
    },
    async dropDownCategoryClick(categoryName, categoryId) {
      this.dropDownProductCategory = categoryName;
      this.category.nameGe = categoryName;
      this.category.id = categoryId;
      this.productMenuGroup.prodCategoryId = categoryId;

      //let productSubCategoriesResult = await this.$http.post(
      //_baseUrl + "get-all-prod-sub-categories-full",
      //{ id: categoryId }
      //);
      //this.productSubCategoriesArray = productSubCategoriesResult.data.res;

      let productSubCategoryResult = await this.$http.getByIDProductSubCategory(
        this.productMenuGroup.prodCategoryId
      );
      this.productSubCategoriesArray = productSubCategoryResult.data.res;

      this.dropDownProductSubCategory = "აირჩიეთ ქვე კატეგორია";
      this.productMenuGroup.prodSubCategoryId = null;

      this.dropDownProductSubSubCategory = "აირჩიეთ ქვე ქვე კატეგორია";
      this.productMenuGroup.prodSubCategory2Id = null;
      this.productSubSubCategoriesArray = [];

      this.filteredProductsArray = [];
      for (let i = 0; i < this.productsArray.length; i++) {
        var cnt = this.productsArray[i].productProdCategoryDetailes.filter(
          (f) => f.categoryId == categoryId
        ).length;

        var cntExists = this.productMenuGroup.products.filter(
          (f) => f.id == this.productsArray[i].id
        ).length;

        if (cnt > 0 && cntExists == 0) {
          this.filteredProductsArray.push(this.productsArray[i]);
        }
      }
    },
    async dropDownSubCategoryClick(subCategoryName, subCategoryId) {
      this.dropDownProductSubCategory = subCategoryName;
      this.subCategory.nameGe = subCategoryName;
      this.subCategory.id = subCategoryId;
      this.productMenuGroup.prodSubCategoryId = subCategoryId;

      let productSubSubCategoryResult =
        await this.$http.getByIDProductSubSubCategory(
          this.productMenuGroup.prodSubCategoryId
        );
      this.productSubSubCategoriesArray = productSubSubCategoryResult.data.res;
      this.dropDownProductSubSubCategory = "აირჩიეთ ქვე ქვე კატეგორია";
      this.productMenuGroup.prodSubCategory2Id = null;
    },
    dropDownSubSubCategoryClick(subSubCategoryName, subSubCategoryId) {
      this.dropDownProductSubSubCategory = subSubCategoryName;
      this.subSubCategory.nameGe = subSubCategoryName;
      this.subSubCategory.id = subSubCategoryId;
      this.productMenuGroup.prodSubCategory2Id = subSubCategoryId;
    },
    onAutocompleteInput(object) {
      this.selectedProductsArray.push(object);
      this.productMenuGroup.products.push({
        id: object.id,
        nameGe: object.nameGe,
        nameEn: object.nameEn,
        nameRu: object.nameRu,
        orderPriority: this.productMenuGroup.products.length + 1,
        image: object.mainImage,
      });
      this.resetAutocomplete = !this.resetAutocomplete;

      let index = this.filteredProductsArray.findIndex(
        (d) => d.id === object.id
      );
      this.filteredProductsArray.splice(index, 1);
    },
    onFileSelected() {
      this.changedPrductImageUpuloadName = this.$refs.file.files[0].name;
      this.changedProduct.image = this.$refs.file.files[0];
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );
      if (this.changedProduct.image) {
        if (/\.(jpe?g|png|gif)$/i.test(this.changedProduct.image.name)) {
          reader.readAsDataURL(this.changedProduct.image);
        }
      }
      this.editImg = true;
    },
    imageUrl(changedPrductImageUpuloadName) {
      if (changedPrductImageUpuloadName !== "Choose FIle ...") {
        return "http://api.wisher.ge:8080/" + changedPrductImageUpuloadName;
      }
    },
    modalPrepareEdit() {
      this.isActiveModalPrepare = true;
    },
    modalPrepare() {
      this.isActiveModalPrepare = false;
      this.isActive = true;
    },
    clearData() {
      this.productMenuGroup.id = null;
      this.productMenuGroup.nameGe = "";
      this.productMenuGroup.nameEn = "";
      this.productMenuGroup.nameRu = "";
      this.productMenuGroup.order = null;
      this.productMenuGroup.prodCategoryId = null;
      this.productMenuGroup.prodSubCategoryId = null;
      this.productMenuGroup.showInSubs = false;
      this.productMenuGroup.showOnDashboard = false;
      this.productMenuGroup.showOnMain = false;
      this.productMenuGroup.showOnlyDashboard = false;
      this.productMenuGroup.showOnlyMain = false;
      this.productMenuGroup.products = [];
      this.productMenuGroup.prodSubCategory2Id = null;
      this.product.id = null;
      this.product.nameGe = "";
      this.product.nameRu = "";
      this.product.descGe = "";
      this.product.descEn = "";
      this.product.descRu = "";
      this.product.image = "";
      this.product.itemPrice = null;
      this.product.ourPrice = null;
      this.product.pointCorrection = "";
      this.product.legalId = "";
      this.product.properties = [];
      this.product.categories = [];
      this.product.subCategories = [];
      this.product.subCategories2 = [];
      this.dropDownProductCategory = "აირჩიეთ კატეგორია";
      this.dropDownProductSubCategory = "აირჩიეთ ქვე კატეგორია";
      this.dropDownProductSubSubCategory = "აირჩიეთ ქვე ქვე კატეგორია";
      this.productAutocompleteArray = [];
      this.selectedProductsArray = [];
      this.resetAutocomplete = !this.resetAutocomplete;

      //this.productCategoriesArray = [];
      this.productSubCategoriesArray = [];
      this.productSubSubCategoriesArray = [];
      this.filteredProductsArray = [];
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/ProductMenuGroup.vue